module.exports = __webpack_public_path__ + "img/GAME_CARDPAIR.bdf75c33.png";